<template>
  <v-dialog :value="dialogProp.show" persistent max-width="700">
    <v-card class="elevation-12">
      <v-toolbar dense :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Добавление позиции к шаблону') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <position-template-info-fix
            v-if="dialogProp.lotTemplate.premiumType === PREMIUM_TYPES.FIX"
            ref="position"
            :lot-owner-organization-name="lotOwnerOrganizationName"
            :validated="createPosition" />
        <position-template-info-differential
            v-else
            ref="position"
            :lot-owner-organization-name="lotOwnerOrganizationName"
            :validated="createPosition" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelConfirmBtn"
            class="ma-1"
            color="primary"
            @click="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueOperationBtn"
            class="ma-1"
            :disabled="isLoading"
            color="primary"
            @click.stop="continueOperation">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import PositionTemplateInfoFix from '@/components/pages/shared/PositionTemplate/PositionTemplateInfoFix.vue'
  import PositionTemplateInfoDifferential from '@/components/pages/shared/PositionTemplate/PositionTemplateInfoDifferential.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions } from 'vuex'
  import { PREMIUM_TYPES } from '@/constants/business'
  import { POSITIONS_TEMPLATE_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      PositionTemplateInfoFix,
      PositionTemplateInfoDifferential
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            lotTemplate: {
              lotTemplateId: null,
              premiumType: null
            },
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        PREMIUM_TYPES,
        isLoading: false
      }
    },
    computed: {
      lotOwnerOrganizationName () {
        return this.dialogProp.lotTemplate?.organizer?.organizationName
      }
    },
    created () {
      if (!this.dialogProp.lotTemplate.premiumType || !this.dialogProp.lotTemplate.lotTemplateId) {
        this.showErrorAction({
          message: this.$t('Торговая процедура не определена.')
        })
      }
    },
    methods: {
      ...mapActions(POSITIONS_TEMPLATE_MANAGEMENT.NAMESPACE, {
        createPositionAction: POSITIONS_TEMPLATE_MANAGEMENT.ACTIONS.CREATE_POSITION_TEMPLATE
      }),
      continueOperation: async function () {
        try {
          this.isLoading = true
          await this.$refs.position.validate()
          if (this.dialogProp.callback) {
            await this.dialogProp.callback()
            this.isLoading = false
            this.cancel()
          }
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      createPosition: async function (position) {
        const model = {
          premiumType: this.dialogProp.lotTemplate.premiumType,
          lotTemplateId: this.dialogProp.lotTemplate.lotTemplateId,
          lotType: this.dialogProp.lotTemplate.lotType,
          position
        }
        await Promise.all([
          this.createPositionAction(model)
        ])
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
